import LocationToggle from './LocationToggle';
import Input from '@/components/ui/Input';
import Toggle from '@/components/ui/Toggle';
import Button from '@/components/ui/Button';
import ImageUrlUploadField from '@/components/ui/ImageUrlUploadField';
import { useTranslation } from '@/hooks/useTranslation';
import { AdCampaignType, HomeCampaignSettings } from '@/types/ads';
import { MediaSource } from '@/types/media';

export default function HomeCampaignFields({ value, type, playbackAsset, onChange, error, readOnly = false, useCreativeAsset = false, disabledReason }: {
  disabledReason?: string; value: HomeCampaignSettings; type?: AdCampaignType | null; playbackAsset?: string;
  onChange?: (value: HomeCampaignSettings) => void; error?: string; readOnly?: boolean; useCreativeAsset?: boolean;
}) {
  const { t } = useTranslation(); const l = t.homeCampaign;
  const media = type === 'BANNER' || type === 'VIDEO';
  const change = (patch: Partial<HomeCampaignSettings>) => onChange?.({ ...value, ...patch, placement: media ? 'HOME_SLIDE' : 'HOME_TICKER' });
  return <section className="space-y-4 border border-gray-200 p-4">
    <div className="flex items-start justify-between gap-3">
      <div>
        <h3 className="text-sm font-medium text-gray-900">{l.title}</h3>
        {value.enabled && <p className="text-xs text-gray-500">{media ? (useCreativeAsset ? t.adCreatives.homeMedia : l.help) : l.tickerHelp}</p>}
      </div>
      <LocationToggle disabledReason={disabledReason} aria-label={l.enabled} checked={value.enabled} disabled={readOnly} onChange={enabled => change({ enabled })} size="sm" className="shrink-0" />
    </div>
    {value.enabled && <>
      {!readOnly && <>
        {media && !useCreativeAsset ? <>
          <ImageUrlUploadField label={l.media} value={value.mediaUrl} onChange={mediaUrl => change({ mediaUrl })} source={MediaSource.HOME_SLIDE} mediaType={type === 'VIDEO' ? 'video' : 'image'} />
          {playbackAsset && <Button type="button" variant="outline" onClick={() => change({ mediaUrl: playbackAsset })}>{l.reuse}</Button>}
        </> : null}
        {media && <div className="grid gap-3 sm:grid-cols-2">
          <Input type="number" label={l.duration} min={5} max={60} value={value.durationSeconds} onChange={e => change({ durationSeconds: Number(e.target.value) })} />
          <Input type="number" label={l.cadence} min={1} max={10} value={value.everyNItems} onChange={e => change({ everyNItems: Number(e.target.value) })} />
        </div>}
        {type === 'VIDEO' && <Toggle label={l.muted} aria-label={l.muted} checked={value.muted} onChange={muted => change({ muted })} size="sm" />}
      </>}
      {error && <p role="alert" className="text-sm text-red-600">{error}</p>}

    </>}
  </section>;
}
